import { observer } from 'mobx-react';
import { LearningCollectionPublishResource } from '../../../../../Store/Types';
import InviteParticipantStore from '../../Store';
import { SelectParticipantsState } from '../../Store/Types';
import Modal from './Modal';

export interface Props {
  state: SelectParticipantsState;
  store: InviteParticipantStore;
  learningCollectionPublishResource: LearningCollectionPublishResource;
}

function SelectParticipantsModal({ store, learningCollectionPublishResource, state }: Props) {
  return (
    <Modal
      state={state}
      modalStore={store.modalStore}
      store={store}
      learningCollectionPublishResource={learningCollectionPublishResource}
    />
  );
}

export default observer(SelectParticipantsModal);
